import { DataType } from "src/app/common/models/enums/common.enum";
import { ReportTableColumn, ReportTableDropdown } from "../../reports-lists/models/reports.model";
import { projectMenuEnum } from "./report-project-menu-enum";

export class ProjectConstant {

    static overViewMenu = [
        {
            label: 'reports.overview',
            name: projectMenuEnum.overview
        },
        {
            label: 'reports.municipalRegulations',
            name: projectMenuEnum.municipalRegulations,
        },
        {
            label: 'reports.landParcelTable',
            name: projectMenuEnum.landParcelTable
        },
        {
            label: 'reports.propertyDetailsHouses',
            name: projectMenuEnum.propertyDetailsHouses
        },
        {
            label: 'reports.propertyDetailsOthers',
            name: projectMenuEnum.propertyDetailsOthers
        },
        {
            label: 'reports.landprices',
            name: projectMenuEnum.landPrices
        },
        {
            label: 'reports.property_prices',
            name: projectMenuEnum.propertyPrices
        },
        {
            label: 'reports.unit_Prices',
            name: projectMenuEnum.unitPrices
        },
        {
            label: 'reports.ResidentialRental',
            name: projectMenuEnum.ResidentialRental
        },
        {
            label: 'reports.RetailRental',
            name: projectMenuEnum.RetailRental
        },
        {
            label: 'reports.OfficeRental',
            name: projectMenuEnum.OfficeRental
        },
        {
            label: 'reports.WarehouseRental',
            name: projectMenuEnum.WarehouseRental
        }


    ]
    //Land Parcel Table Columns
    static landParcelColumns: ReportTableColumn[] = [
        {
            header: 'parcel_number',
            columnName: 'reports.parcelNumber',
            field: 'parcel_number',
            isSortable: true,
            border: false,
            isContainsHTML: false,
        },
        {
            header: 'land_area',
            columnName: 'reports.land_area',
            field: 'land_area',
            border: false,
            isSortable: true,
            convertNumber: true,
            symbol: DataType.squareMeter,
        },
        {
            header: 'zoning',
            columnName: 'reports.zoning_label',
            field: 'zoning',
            isSortable: true,
            border: false,
            isContainsHTML: false,
        }
    ]
    //Property Details - Houses Columns
    static propertyHousesColumns: ReportTableColumn[] = [
        {
            header: 'type',
            columnName: 'reports.type',
            field: 'type',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            showOnMap: true,
            isAnchor: true,
        },
        {
            header: 'block',
            columnName: 'reports.block',
            field: 'block',
            border: false,
            isSortable: true,
        },
        {
            header: 'total_buildup_area',
            columnName: 'reports.builtUpArea',
            field: 'total_buildup_area',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'floors',
            columnName: 'reports.no_of_floor',
            field: 'floors',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'no_of_bedroom',
            columnName: 'reports.no_of_bedroom',
            field: 'no_of_bedroom',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'no_of_bathroom',
            columnName: 'reports.no_of_bathroom',
            field: 'no_of_bathroom',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'property_uid',
            columnName: 'reports.property_uid',
            field: 'property_uid',
            isSortable: true,
            border: false,
            isContainsHTML: false
        }
    ]
    //Property Details - Others Columns
    static propertyOthersColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.PropertyName',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'parcel_no',
            columnName: 'reports.parcelNumber',
            field: 'parcel_no',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: false,
            isAnchor: false
        },
        {
            header: 'property_type',
            columnName: 'reports.property_type',
            field: 'property_type',
            border: false,
            isSortable: false,
        },
        {
            header: 'development_status',
            columnName: 'reports.developmentStatus',
            field: 'development_status',
            border: false,
            isSortable: false,
        },
        {
            header: 'total_buildup_area',
            columnName: 'reports.builtUpArea',
            field: 'total_buildup_area',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'total_gla',
            columnName: 'reports.gla',
            field: 'total_gla',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'no_of_floors',
            columnName: 'reports.no_of_floor',
            field: 'no_of_floors',
            isSortable: false,
            border: false,
            isContainsHTML: false
        }
    ]

    //Property Details - Residential Columns
    static residentialColumns: ReportTableColumn[] = [
    {
        header: 'type',
        columnName: 'reports.type',
        field: 'type',
        isSortable: false,
        border: false
    },
    {
        header: 'average_size',
        columnName: 'reports.avg_size',
        field: 'average_size',
        isSortable: false,
        border: false,
        symbol: DataType.squareMeter,
    },
    {
        header: 'rentals_as_lumpsum',
        columnName: 'reports.avg_rental_as_lumpsum',
        field: 'rentals_as_lumpsum',
        isSortable: false,
        border: false,
        symbol: DataType.currencyCode
    },
    {
        header: 'rental_rate',
        columnName: 'reports.avg_rent_rate',
        field: 'rental_rate',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    ];

    //Property Details - Retail Columns
    static retailColumns: ReportTableColumn[] = [
    {
        header: 'unit_size',
        columnName: 'reports.unit_size',
        field: 'unit_size',
        isSortable: false,
        border: false,
        symbol: DataType.squareMeter,
    },
    {
        header: 'all_floors',
        columnName: 'reports.all_floors',
        field: 'all_floor_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'lower_ground',
        columnName: 'reports.lower_ground',
        field: 'lower_ground_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'ground',
        columnName: 'reports.ground',
        field: 'ground_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'first_floor',
        columnName: '1Floor',
        field: 'first_floor_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'second_floor',
        columnName: '2Floor',
        field: 'second_floor_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'third_floor',
        columnName: '3Floor',
        field: 'third_floor_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'higher_floor',
        columnName: 'reports.higher_floors', // missing key added
        field: 'higher_floor_range',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    }
    ];

    //Property Details - Office Columns
    static officeColumns: ReportTableColumn[] = [
   {
        header: 'unit_size',
        columnName: 'reports.unit_size',
        field: 'unit_size',
        isSortable: false,
        border: false,
        symbol: DataType.squareMeter,
    },
    {
        header: 'grade_a_plus',
        columnName: 'reports.grade_a+',
        field: 'grade_a_plus',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'grade_a',
        columnName: 'reports.grade_a',
        field: 'grade_a',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'grade_b',
        columnName: 'reports.grade_b',
        field: 'grade_b',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'grade_c',
        columnName: 'reports.grade_c',
        field: 'grade_c',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'Grade_Undefined',
        columnName: 'reports.Grade_Undefined',
        field: 'grade_undefined',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    }
    ];

    //Property Details - Warehouse Rental Columns
    static warehouseColumns: ReportTableColumn[] = [
    {
        header: 'unit_size',
        columnName: 'reports.unit_size',
        field: 'unit_size',
        isSortable: false,
        border: false,
        symbol: DataType.squareMeter,
    },
    {
        header: 'dry_warehouse',
        columnName: 'reports.dry_warehouse',
        field: 'dry_warehouse',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'ambient',
        columnName: 'reports.ambient',
        field: 'ambient',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'cold_storage',
        columnName: 'reports.cold_storage',
        field: 'cold_storage',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
        header: 'frozen_warehouse',
        columnName: 'reports.frozen_warehouse',
        field: 'frozen_warehouse',
        isSortable: false,
        border: false,
        symbol: DataType.currencyWithSquareMeter,
    }
    ];


      //Land Prices Columns
    static landPricesColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.property_uid',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'transactionDate',
            columnName: 'reports.transactionDate',
            field: 'transaction_date',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: false,
            isAnchor: false
        },
        {
            header: 'price_type',
            columnName: 'reports.priceType',
            field: 'price_type',
            border: false,
            isSortable: false,
            symbol: DataType.source
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: false,
            symbol: DataType.currencyCode,
            recordType: true,
            valSymbol: '',
            isContainsHTML: false,
            convertNumber: true,
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.currencyWithSquareMeter
        },
        {
            header: 'parcelNumber',
            columnName: 'reports.parcelNumber',
            field: 'parcel_no',
            isSortable: false,
            border: false,
            isContainsHTML: false
        }
    ]
          //Land Prices Columns
    static propertyPricesColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.propertyNameAndUID',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'parcel_no',
            columnName: 'reports.parcelNumber',
            field: 'parcel_no',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: false,
            isAnchor: false
          },
        {
            header: 'transactionDate',
            columnName: 'reports.transactionDate',
            field: 'transactionDate',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: false,
            isAnchor: false
        },
        {
            header: 'type',
            columnName: 'reports.type',
            field: 'type',
            isSortable: false,
            border: false
        },
        {
            header: 'priceType',
            columnName: 'reports.priceType',
            field: 'priceType',
            border: false,
            isSortable: false,
            symbol: DataType.source
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: false,
            symbol: DataType.currencyCode,
            recordType: true,
            isContainsHTML: false,
            convertNumber: true,
            valSymbol: '',
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.currencyWithSquareMeter
        }
    ]

             //Land Prices Columns
    static projectUnitPricesColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.propertyNameAndUID',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'transactionDate',
            columnName: 'reports.transactionDate',
            field: 'transactionDate',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            showOnMap: false,
            isAnchor: false
        },
        {
            header: 'type',
            columnName: 'reports.type',
            field: 'type',
            isSortable: false,
            border: false
        },
        {
            header: 'priceType',
            columnName: 'reports.priceType',
            field: 'priceType',
            border: false,
            isSortable: false,
            symbol: DataType.source
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: false,
            symbol: DataType.currencyCode,
            recordType: true,
            isContainsHTML: false,
            convertNumber: true,
            valSymbol: '',
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            symbol: DataType.currencyWithSquareMeter
        },
        {
            header: 'Unit_uid',
            columnName: 'reports.unit_uid',
            field: 'unit_uid',
            isSortable: false,
            border: false,
            isContainsHTML: false
        }
    ]


}
